import { useFeatureFlags } from 'components/FeatureFlags';
import {
  Actions,
  Subjects,
  useIsRbacEnabled,
  useIsTeamMultiSeat,
  useIsUserTeamAdminOrOwner,
  useUserAbilitiesContext,
  useIsWellSaidAdmin,
} from 'context/user/UserContext';

export const useCanReadTeamVoices = () => {
  const isWSLAdmin = useIsWellSaidAdmin();
  const isRBACEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();
  const isTeamVoicesEnabledLegacy = ability.can(Actions.View, Subjects.Voices);
  const isTeamVoicesEnabledRbac = ability.can(
    Actions.Read,
    Subjects.TeamVoices
  );

  return (
    isWSLAdmin ||
    (isRBACEnabled ? isTeamVoicesEnabledRbac : isTeamVoicesEnabledLegacy)
  );
};

export const useCanUpdateTeamVoices = () => {
  const isMultiSeat = useIsTeamMultiSeat();
  const isTeamAdminOrOwnerUser = useIsUserTeamAdminOrOwner();
  const isTeamAdminOrOwner = isTeamAdminOrOwnerUser && isMultiSeat;
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();

  const canUpdateTeamVoiceLegacy = isTeamAdminOrOwner;
  const canUpdateTeamVoiceRbac = ability.can(
    Actions.Update,
    Subjects.TeamVoices
  );

  return isRbacEnabled ? canUpdateTeamVoiceRbac : canUpdateTeamVoiceLegacy;
};

export const useCanReadVoicesPage = () => {
  const ability = useUserAbilitiesContext();
  return ability.can(Actions.Read, Subjects.PageVoices);
};

export const useCanAuditionVoices = () => {
  const ability = useUserAbilitiesContext();
  const { isFeatureEnabled } = useFeatureFlags();
  return (
    isFeatureEnabled('llm-voice-audition') &&
    ability.can(Actions.Read, Subjects.PageVoices)
  );
};
